import { ISortFunction } from '@move-frontend/utils';
import { SuggestionStore } from './SuggestionStore';
import { IFlightSearchSuggestion } from '../models/IFlightSearchSuggestion';
import { normalizeSearchValue } from '../../../shared/normalizeSearchValue';

export function sortFlightSuggestions(
	suggestionStore: SuggestionStore<IFlightSearchSuggestion>,
) {
	const byIndexAndResultLength: ISortFunction<IFlightSearchSuggestion> = (
		a: IFlightSearchSuggestion,
		b: IFlightSearchSuggestion,
	) => {
		const query = normalizeSearchValue(suggestionStore.query);
		const normalizedA = normalizeSearchValue(a.value);
		const normalizedB = normalizeSearchValue(b.value);

		return (
			normalizedA.indexOf(query) - normalizedB.indexOf(query) ||
			a.value.length - b.value.length
		);
	};

	return { byIndexAndResultLength };
}
